import Alpine from "alpinejs";
import { scrollTo } from "../../modules/scrollTo";
Alpine.magic("scrollTo", () => (scrollToElement, ops) => {
  scrollTo(scrollToElement, ops);
});
